@if (isModal()) {
  <app-modal-header (closeModal)="close()"></app-modal-header>
}
@if (isLoading()) {
  <div class="d-flex justify-content-center align-items-center py-5 my-5">
    <div class="spinner-border text-primary" role="status"></div>
  </div>
}
@if (loadError()) {
  <div class="text-center py-5 my-5">
    <i class="bi bi-exclamation-triangle text-danger display-4"></i>
    <p class="mt-3">{{ 'SOMETHING_WENT_WRONG' | translate }}</p>
    <div>
      <button class="btn d-inline btn-light rounded-5 fw-medium ms-1" (click)="retryLoad()">
        {{ 'RETRY' | translate }}
      </button>
    </div>
  </div>
}
<div #containerRef class="modal-external-floorplan-container" [class.d-none]="isLoading() || loadError()"></div>
